/**
 * * Получить расширение из названия файла
 * @param fileName Название файла с расширением
 * @returns
 */
export const getFileExtension = (fileName: string): string | undefined => {
  // Разбиваем имя файла на части, используя "." в качестве разделителя
  const fileNameParts = fileName.split(".");

  // Если в имени файла нет точки или это не похоже на расширение, возвращаем
  if (fileNameParts.length < 2) {
    return;
  }

  // Возвращаем последнюю часть после последней точки, которая является расширением файла
  return fileNameParts.pop() || undefined;
};
